import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import type { UsageResponse } from "../types";

export function UsageTable({ data, loading }: { data: UsageResponse | null; loading: boolean }) {
  if (loading) {
    return (
      <Typography variant="body1" sx={{ p: 2, color: "text.secondary" }}>
        Loading…
      </Typography>
    );
  }

  if (!data) {
    return (
      <Typography variant="body1" sx={{ p: 2, color: "text.secondary" }}>
        Pick a customer and date range, then click Refresh.
      </Typography>
    );
  }

  if (data.buckets.length === 0) {
    return (
      <Typography variant="body1" sx={{ p: 2, color: "text.secondary" }}>
        No events in this period.
      </Typography>
    );
  }

  const groupHeader = data.grouped_by
    ? labelFor(data.grouped_by)
    : "Total";

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{groupHeader}</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align="right">Events</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.buckets.map((b, idx) => (
            <TableRow key={String(b.key) + idx}>
              <TableCell>{b.key ?? "(unattributed)"}</TableCell>
              <TableCell align="right">{b.total.toLocaleString()}</TableCell>
              <TableCell align="right">{b.event_count.toLocaleString()}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Grand total</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>
              {data.grand_total.toLocaleString()}
            </TableCell>
            <TableCell />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function labelFor(col: string): string {
  return ({
    case_id: "Case",
    feature_id: "Feature",
    user_id: "User",
    query_type: "Query type",
  } as Record<string, string>)[col] ?? col;
}
